/**
 * Helper functions for Faceboom entry point and entry point data.
 */
import { jsonStringifyNoThrow } from './util';
/**
 * Returns a 'sanitized' struct with entry point name and JSON.stringified() entry point data.
 *
 * The eventPointData should look something like this:
 *
 * {
 *     name: 'game_switch',
 *     data: '{ ... }'
 * }
 *
 * @param fbEntryPoint (resolved!) result of FBInstant.getEntryPointAsync()
 * @param fbEntryPointData the result of FBInstant.getEntryPointData()
 * @return a populated EntryPointData object
 */
export function extractEntryPointData(fbEntryPoint, fbEntryPointData) {
    return {
        name: fbEntryPoint !== null && fbEntryPoint !== void 0 ? fbEntryPoint : 'undefined_or_null',
        data: fbEntryPointData ? jsonStringifyNoThrow(fbEntryPointData) : undefined,
    };
}
//# sourceMappingURL=fbentrypoint.js.map